import styled from '@emotion/styled';
import { Modal as ModalBase } from '@ui-components/neo.tax';

export const RdProjectEligibilityModal = styled(ModalBase)({
  maxWidth: '750px',
  width: '100%',
});
